(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v1"] && !Shopify.designMode) return;
  try {
    
// Enhanced Video Slideshow Functionality
document.addEventListener('DOMContentLoaded', function() {
  
  // Function to handle video autoplay and looping
  function initializeSlideshowVideos() {
    const videos = document.querySelectorAll('.slideshow-video');
    console.log('🎬 Found slideshow videos:', videos.length);
    
    if (videos.length === 0) {
      console.log('❌ No slideshow videos found. Possible issues:');
      console.log('   1. Media Type is not set to "Video File"');
      console.log('   2. No video file uploaded in theme customizer');
      console.log('   3. Slideshow section not configured correctly');
      return;
    }
    
    videos.forEach(function(video, index) {
      console.log('Initializing video', index, ':', video);
      
      // Check if video is in DOM and visible
      if (!document.body.contains(video)) {
        console.log('Video not in DOM, skipping');
        return;
      }
      
      const sources = video.querySelectorAll('source');
      const sourceSrcs = Array.from(sources).map(s => s.src);
      console.log('Video sources:', sourceSrcs);
      
      // Enhanced URL debugging and fixing
      if (sources.length > 0) {
        const source = sources[0];
        const originalUrl = source.dataset.originalUrl || source.src;
        const fixedUrl = source.dataset.fixedUrl || source.src;
        
        console.log('Video source details:', {
          originalUrl: originalUrl,
          currentSrc: source.src,
          fixedUrl: fixedUrl,
          hasExtension: source.src.includes('.mp4') || source.src.includes('.webm') || source.src.includes('.mov'),
          needsFixing: !source.src.includes('.mp4') && !source.src.includes('.webm') && !source.src.includes('.mov'),
          urlParts: source.src.split('?'),
          baseUrl: source.src.split('?')[0],
          queryParams: source.src.includes('?') ? source.src.split('?')[1] : 'none'
        });

        // Show exactly what Liquid processing did
        console.log('Liquid processing trace:', {
          liquidProcessedUrl: fixedUrl,
          jsCurrentSrc: source.src,
          dataAttributes: {
            originalUrl: source.dataset.originalUrl,
            fixedUrl: source.dataset.fixedUrl
          },
          shopifyFileUrl: originalUrl
        });
        
        // JavaScript fallback URL correction
        if (!source.src.includes('.mp4') && !source.src.includes('.webm') && !source.src.includes('.mov')) {
          console.log('URL needs extension, applying JavaScript fix...');
          const urlParts = source.src.split('?');
          const baseUrl = urlParts[0];
          const correctedUrl = baseUrl + '.mp4';
          
          console.log('Correcting URL from', source.src, 'to', correctedUrl);
          source.src = correctedUrl;
          video.load(); // Reload with corrected URL
        }
        
        // Test if video URL is accessible
        const testUrl = source.src;
        if (testUrl && testUrl !== '') {
          console.log('Testing video URL accessibility:', testUrl);
          
          // Create a test video element to check if URL loads
          const testVideo = document.createElement('video');
          testVideo.preload = 'metadata';
          testVideo.muted = true;
          
          testVideo.addEventListener('loadedmetadata', function() {
            console.log('✅ Video URL is accessible:', testUrl);
          });
          
          testVideo.addEventListener('error', function(e) {
            console.log('❌ Video URL failed to load:', testUrl);
            console.log('   Error code:', this.error?.code);
            console.log('   This may indicate the video file does not exist on the server');
          });
          
          testVideo.src = testUrl;
        }
      } else {
        console.log('No sources found');
      }
      
      // Ensure video properties are set
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.preload = 'metadata';
      
      // Debug video visibility
      console.log('Video dimensions:', video.offsetWidth, 'x', video.offsetHeight);
      console.log('Video display:', window.getComputedStyle(video).display);
      console.log('Video visibility:', window.getComputedStyle(video).visibility);
      
      // Fix mobile video loading issue with extremely aggressive approach
      if (video.offsetWidth === 0 || video.offsetHeight === 0) {
        console.log('Video has 0 dimensions, attempting super aggressive fix...');
        
        // Get all parent containers up the chain
        const container = video.closest('.slideshow-video-container');
        const pictureSlideshow = video.closest('.picture-slideshow');
        const infoSideh1 = video.closest('.info-sideh1');
        const slideItem = video.closest('.itemv-slide-h1');
        
        // Force dimensions on video element
        video.style.cssText = `
          width: 100vw !important;
          height: 100vh !important;
          min-width: 100% !important;
          min-height: 400px !important;
          max-width: none !important;
          max-height: none !important;
          display: block !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          object-fit: cover !important;
          object-position: center !important;
          z-index: 1 !important;
        `;
        
        // Force dimensions on all parent containers
        [container, pictureSlideshow, infoSideh1, slideItem].forEach(function(el) {
          if (el) {
            el.style.setProperty('width', '100%', 'important');
            el.style.setProperty('height', '100%', 'important');
            el.style.setProperty('min-height', '400px', 'important');
            el.style.setProperty('position', 'relative', 'important');
            el.style.setProperty('overflow', 'hidden', 'important');
          }
        });
        
        // Special handling for mobile containers
        if (video.classList.contains('slideshow-video--mobile')) {
          const mobileContainer = video.closest('.d-block.d-md-none');
          if (mobileContainer) {
            mobileContainer.style.cssText = `
              width: 100% !important;
              height: 100vh !important;
              min-height: 400px !important;
              position: relative !important;
              display: block !important;
            `;
          }
        }
        
        // Force reload
        video.load();
        
        // Multiple dimension checks
        setTimeout(function() {
          console.log('Rechecking video dimensions after 1s:', video.offsetWidth, 'x', video.offsetHeight);
          if (video.offsetWidth === 0 || video.offsetHeight === 0) {
            console.log('Still 0 dimensions, trying viewport units...');
            video.style.cssText += `
              width: 100vw !important;
              height: 50vh !important;
            `;
          }
        }, 1000);
        
        setTimeout(function() {
          console.log('Final dimension check after 3s:', video.offsetWidth, 'x', video.offsetHeight);
          
          // If still 0x0 after 3 seconds, try extreme measures
          if (video.offsetWidth === 0 || video.offsetHeight === 0) {
            console.log('CRITICAL: Video still has 0 dimensions after all fixes. Trying extreme measures...');
            
            // Create a new video element and replace the old one
            const newVideo = document.createElement('video');
            newVideo.className = video.className;
            newVideo.style.cssText = `
              width: 100vw !important;
              height: 100vh !important;
              min-width: 100vw !important;
              min-height: 400px !important;
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              z-index: -1 !important;
              object-fit: cover !important;
              display: block !important;
            `;
            newVideo.autoplay = true;
            newVideo.muted = true;
            newVideo.loop = true;
            newVideo.playsInline = true;
            
            // Copy sources
            const sources = video.querySelectorAll('source');
            sources.forEach(function(source) {
              const newSource = document.createElement('source');
              newSource.src = source.src;
              newSource.type = source.type;
              newVideo.appendChild(newSource);
            });
            
            // Replace the video
            video.parentElement.appendChild(newVideo);
            video.remove();
            
            console.log('Replaced video element. New dimensions:', newVideo.offsetWidth, 'x', newVideo.offsetHeight);
            
            // Try to play the new video
            setTimeout(function() {
              newVideo.play().catch(function(e) {
                console.log('Replaced video play failed:', e);
              });
            }, 100);
          }
        }, 3000);
      }
      
      // Handle different video loading states
      video.addEventListener('loadstart', function() {
        console.log('Video', index, 'loadstart');
      });
      
      video.addEventListener('canplay', function() {
        console.log('Video', index, 'canplay');
        if (document.body.contains(this)) {
          this.play().catch(function(e) {
            console.log('Play on canplay failed:', e);
          });
        }
      });
      
      video.addEventListener('loadedmetadata', function() {
        console.log('Video', index, 'metadata loaded:', this.videoWidth, 'x', this.videoHeight);
        if (this.videoWidth === 0 || this.videoHeight === 0) {
          console.log('Video has no dimensions after metadata load, reloading...');
          this.load();
        }
      });
      
      video.addEventListener('error', function(e) {
        console.error('Video', index, 'error:', e, this.error);
        
        // Check for specific error types
        if (this.error) {
          console.error('Video error details:', {
            code: this.error.code,
            message: this.error.message || 'Unknown error'
          });
          
          // Handle 404 errors (MEDIA_ERR_SRC_NOT_SUPPORTED = 4)
          if (this.error.code === 4) {
            console.log('404 error detected - video file not found or wrong format');
            
            const source = this.querySelector('source');
            const currentSrc = source?.src;
            const attemptCount = parseInt(source?.dataset.fallbackAttempts || '0');
            
            if (currentSrc && source && attemptCount === 0) {
              // First attempt - set up comprehensive fallback URLs
              const baseUrl = currentSrc.split('?')[0];
              const fileName = baseUrl.split('/').pop();
              const basePath = baseUrl.substring(0, baseUrl.lastIndexOf('/') + 1);
              
              let attempts = [
                currentSrc + '.mp4',                           // Original + .mp4
                currentSrc.split('?')[0] + '.mp4',            // No query + .mp4
                currentSrc.replace(/\?.*$/, '') + '.mp4',     // Regex clean + .mp4
                basePath + fileName + '.mp4',                 // Clean path reconstruction
                basePath + 'videos/' + fileName + '.mp4',     // Try videos folder
                currentSrc + '.webm',                         // Try webm format
                currentSrc.split('?')[0] + '.webm'           // Clean webm
              ];
              
              console.log('Setting up comprehensive fallback URLs:', attempts);
              console.log('Original URL analysis:', {
                currentSrc: currentSrc,
                baseUrl: baseUrl,
                fileName: fileName,
                basePath: basePath
              });
              
              source.dataset.fallbackUrls = JSON.stringify(attempts);
              source.dataset.fallbackAttempts = '1';
              source.src = attempts[0];
              this.load();
              return;
            } else if (source?.dataset.fallbackUrls) {
              // Try next fallback URL
              try {
                const remainingUrls = JSON.parse(source.dataset.fallbackUrls);
                const nextAttempt = parseInt(source.dataset.fallbackAttempts || '0');
                
                if (remainingUrls.length > nextAttempt - 1) {
                  console.log('Trying fallback URL #' + nextAttempt + ':', remainingUrls[nextAttempt - 1]);
                  source.src = remainingUrls[nextAttempt - 1];
                  source.dataset.fallbackAttempts = (nextAttempt + 1).toString();
                  this.load();
                  return;
                } else {
                  console.log('All fallback URLs exhausted - video file may not exist on server');
                  console.log('🚨 IMPORTANT: Check your Shopify admin video upload:');
                  console.log('   1. Go to Content → Files in Shopify admin');
                  console.log('   2. Check if your video file was uploaded correctly');  
                  console.log('   3. Copy the exact file URL from Shopify admin');
                  console.log('   4. The URL should end with .mp4, .webm, or .mov');
                  console.log('   5. Original URL attempted:', currentSrc);
                }
              } catch (err) {
                console.log('Error parsing fallback URLs:', err);
              }
            }
          }
        }
        
        // Hide video element if it continues to fail
        console.log('Video failed to load completely, showing fallback');
        this.style.display = 'none';
        
        // Show fallback image if available
        const container = this.closest('.slideshow-video-container') || this.parentElement;
        const fallbackImg = container?.parentElement?.querySelector('.video-fallback-image img') || 
                           container?.parentElement?.querySelector('img.video-fallback-image') ||
                           document.querySelector('.video-fallback-image');
        
        if (fallbackImg) {
          console.log('Showing fallback image for failed video');
          fallbackImg.style.display = 'block';
          // Hide the video container
          if (container) {
            container.style.display = 'none';
          }
        } else {
          console.log('No fallback image found for failed video');
        }
      });
      
      // Enhanced play function with DOM check and retry limit
      let playRetryCount = 0;
      const maxRetries = 3;
      
      function safePlay(video, retryCount = 0) {
        if (!document.body.contains(video)) {
          console.log('Video not in DOM, cannot play');
          return Promise.reject('Video not in DOM');
        }
        
        return video.play().catch(function(error) {
          if (error.name === 'AbortError' && retryCount < maxRetries) {
            console.log('Video play aborted (attempt ' + (retryCount + 1) + '/' + maxRetries + '), retrying in 200ms');
            return new Promise(function(resolve, reject) {
              setTimeout(function() {
                if (document.body.contains(video)) {
                  safePlay(video, retryCount + 1).then(resolve).catch(reject);
                } else {
                  reject('Video removed from DOM during retry');
                }
              }, 200);
            });
          } else if (error.name === 'NotAllowedError') {
            console.log('Video autoplay blocked by browser policy');
            return Promise.reject(error);
          } else {
            console.log('Video play failed:', error.name, error.message);
            return Promise.reject(error);
          }
        });
      }
      
      // Try to play the video with enhanced error handling
      safePlay(video).then(function() {
        console.log('Slideshow video', index, 'started successfully');
      }).catch(function(error) {
        console.log('Autoplay prevented for slideshow video', index, ':', error);
        
        // Try to play on user interaction
        const playOnInteraction = function() {
          if (document.body.contains(video)) {
            safePlay(video).catch(function(e) {
              console.log('Manual play failed:', e);
            });
          }
          document.removeEventListener('click', playOnInteraction);
          document.removeEventListener('touchstart', playOnInteraction);
        };
        
        document.addEventListener('click', playOnInteraction, { once: true });
        document.addEventListener('touchstart', playOnInteraction, { once: true });
      });
      
      // Handle video ended event to ensure proper looping
      video.addEventListener('ended', function() {
        if (document.body.contains(this)) {
          this.currentTime = 0;
          safePlay(this);
        }
      });
      
      // Handle video load events
      video.addEventListener('loadeddata', function() {
        console.log('Video', index, 'data loaded, attempting play');
        if (document.body.contains(this)) {
          safePlay(this);
        }
      });
    });
  }
  
  // Function to handle iframe videos with enhanced UI hiding
  function initializeSlideshowIframes() {
    const iframes = document.querySelectorAll('.slideshow-iframe-wrapper iframe');
    console.log('Found slideshow iframes:', iframes.length);
    
    iframes.forEach(function(iframe, index) {
      console.log('Initializing iframe', index, '- URL:', iframe.src);
      
      // Add additional parameters if not already present
      let src = iframe.src;
      
      if (src.includes('youtube.com') || src.includes('youtu.be')) {
        console.log('Processing YouTube iframe...');
        
        // Enhanced YouTube parameters for complete UI hiding
        const params = [
          'autoplay=1',
          'mute=1', 
          'loop=1',
          'controls=0',
          'showinfo=0',
          'rel=0',
          'modestbranding=1',
          'playsinline=1',
          'cc_load_policy=0',
          'enablejsapi=0',
          'branding=0',
          'autohide=1',
          'theme=dark',
          'color=white',
          'iv_load_policy=3',
          'fs=0',
          'disablekb=1'
        ];
        
        params.forEach(function(param) {
          if (!src.includes(param.split('=')[0])) {
            src += (src.includes('?') ? '&' : '?') + param;
          }
        });
        
        console.log('Updated YouTube URL:', src);
        iframe.src = src;
        
        // Additional JavaScript-based UI hiding
        iframe.addEventListener('load', function() {
          console.log('YouTube iframe loaded, attempting to hide UI elements');
          
          // Try to access iframe content (may fail due to CORS)
          try {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            if (iframeDoc) {
              // Hide any YouTube UI elements
              const style = iframeDoc.createElement('style');
              style.textContent = `
                .ytp-chrome-top, .ytp-chrome-bottom, .ytp-watermark, 
                .ytp-gradient-top, .ytp-gradient-bottom, .ytp-show-cards-title,
                .ytp-pause-overlay, .ytp-title-channel, .ytp-title-expanded-heading,
                .ytp-videowall-still, .ytp-ce-element, .ytp-cards-teaser { 
                  display: none !important; 
                  opacity: 0 !important;
                  visibility: hidden !important;
                }
              `;
              iframeDoc.head.appendChild(style);
            }
          } catch (e) {
            console.log('Cannot access iframe content (CORS restriction):', e.message);
          }
        });
        
      } else if (src.includes('vimeo.com')) {
        console.log('Processing Vimeo iframe...');
        
        // Ensure Vimeo parameters
        const params = [
          'autoplay=1',
          'muted=1',
          'loop=1', 
          'controls=0',
          'playsinline=1'
        ];
        
        params.forEach(function(param) {
          if (!src.includes(param.split('=')[0])) {
            src += (src.includes('?') ? '&' : '?') + param;
          }
        });
        
        console.log('Updated Vimeo URL:', src);
        iframe.src = src;
      }
    });
  }
  
  // Function to handle slideshow changes (if using slick or similar)
  function handleSlideChange() {
    console.log('Slideshow change detected, reinitializing videos...');
    // Small delay to ensure DOM is updated
    setTimeout(function() {
      initializeSlideshowVideos();
    }, 200);
  }
  
  // Robust initialization with multiple attempts
  function robustInitialization() {
    console.log('Starting robust video initialization...');
    initializeSlideshowVideos();
    initializeSlideshowIframes();
    
    // Retry after DOM might have changed
    setTimeout(function() {
      console.log('Retry initialization after 1s...');
      initializeSlideshowVideos();
    }, 1000);
    
    // Final retry for slow-loading content
    setTimeout(function() {
      console.log('Final retry initialization after 3s...');
      initializeSlideshowVideos();
    }, 3000);
  }
  
  // Initialize on page load
  robustInitialization();
  
  // Listen for slideshow events (common carousel libraries)
  const slideshow = document.querySelector('.slick-side-h1');
  if (slideshow) {
    console.log('Slideshow container found, adding event listeners');
    // Slick carousel events
    if (typeof $ !== 'undefined' && $(slideshow).slick) {
      $(slideshow).on('beforeChange', function() {
        console.log('Slick beforeChange');
      });
      $(slideshow).on('afterChange', function() {
        console.log('Slick afterChange');
        handleSlideChange();
      });
    }
  }
  
  // Also listen for any DOM mutations that might affect videos
  if ('MutationObserver' in window) {
    const observer = new MutationObserver(function(mutations) {
      let shouldReinitialize = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Check if video elements were added or removed
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.querySelector && node.querySelector('.slideshow-video'))) {
              shouldReinitialize = true;
            }
          });
        }
      });
      
      if (shouldReinitialize) {
        console.log('Video elements detected in DOM mutation, reinitializing...');
        setTimeout(initializeSlideshowVideos, 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Handle visibility changes to restart videos
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      setTimeout(initializeSlideshowVideos, 500);
    }
  });
  
  // Intersection Observer for better performance
  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        const video = entry.target;
        
        if (entry.isIntersecting) {
          // Video is visible, ensure it's playing
          if (video.paused) {
            video.play().catch(function(e) {
              console.log('Intersection play failed:', e);
            });
          }
        } else {
          // Video is not visible, pause to save resources
          if (!video.paused) {
            video.pause();
          }
        }
      });
    }, {
      threshold: 0.5
    });
    
    // Observe all slideshow videos
    document.querySelectorAll('.slideshow-video').forEach(function(video) {
      videoObserver.observe(video);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
